import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import CasoSospetto from "./Sezioni/CasoSospetto";
import DatiSegnalazioneMorbillo from "./Sezioni/DatiSegnalazioneMorbillo";
import DatiAnagraficiPazienteMorbillo from "./Sezioni/DatiAnagraficiPazienteMorbillo";
import CollettivitaFrequentata from "./Sezioni/CollettivitaFrequentata";
import StatoVaccinale from "./Sezioni/StatoVaccinale";
import DatiClinici from "./Sezioni/DatiClinici";
import ConfermaDiLaboratorio from "./Sezioni/ConfermaDiLaboratorio/ConfermaDiLaboratorio";
import EsamiEComplicanze from "./Sezioni/EsamiEComplicanze";
import Ricovero from "./Sezioni/Ricovero";
import OrigineDelContagio from "./Sezioni/OrigineDelContagio";
import ContattiConDonneInGravidanza from "./Sezioni/ContattiConDonneInGravidanza";
import ClassificazioneDelCaso from "./Sezioni/ClassificazioneDelCaso";
import DatiDelCompilatoreMorbillo from "./Sezioni/DatiDelCompilatoreMorbillo";
import Utils from "../../../../../../utils/Utils";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import SessioneUtente from "../../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../../utils/Ruoli";

class SchedaSpecialeMorbilloRosolia extends Component {

    state = {
        correttezzaStep: {
            casoSospetto: [],
            datiSegnalazione: [],
            datiPaziente: [],
            collettivitaFrequentata: [],
            statoVaccinale: [],
            datiClinici: [],
            confermaDiLaboratorio: [],
            esamiEComplicanze: [],
            ricovero: [],
            origineDelContagio: [],
            contattiConDonneInGravidanza: [],
            classificazioneDelCaso: [],
            datiDelCompilatore: [],
        },
        oggettoBE: {},
        validateMorbilloRosolia: {}
    }

    constructor(props) {
        super(props);
        this.createOggettoBeAndcontrolloCorrettezza = this.createOggettoBeAndcontrolloCorrettezza.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.pulisciOggettoBE = this.pulisciOggettoBE.bind(this)
        this.validate = this.validate.bind(this);
    }

    createOggettoBeAndcontrolloCorrettezza(nameObject, object, corretto, validateGenerico) {
        let oggettoBe = this.state.oggettoBE
        oggettoBe[nameObject] = object
        let correttezzaStep = this.state.correttezzaStep
        correttezzaStep[nameObject] = corretto
        let validate = this.state.validateMorbilloRosolia
        validate[nameObject] = validateGenerico

        if (object && corretto && validateGenerico) {
            this.setState({correttezzaStep: correttezzaStep, oggettoBe: oggettoBe, validateMorbilloRosolia: validate})
        } else if (!corretto && object && validateGenerico) {
            this.setState({oggettoBe: oggettoBe, validateTubercolosi: validate})
        } else if (corretto && !object && validateGenerico) {
            this.setState({correttezzaStep: correttezzaStep, validateTubercolosi: validate})
        } else if (corretto && object && !validateGenerico) {
            this.setState({oggettoBe: oggettoBe, correttezzaStep: correttezzaStep})
        } else if (corretto && !object && !validateGenerico) {
            this.setState({correttezzaStep: correttezzaStep})
        } else if (!corretto && object && !validateGenerico) {
            this.setState({oggettoBe: oggettoBe})
        } else if (!corretto && !object && validateGenerico) {
            this.setState({validateTubercolosi: validate})
        }

        let correttoFinale = this.controlloCorrettezza()
        let oggettoBEFinale = this.pulisciOggettoBE()
        this.props.setSchedaSpecialeECorretto(oggettoBEFinale, this.validate(), correttoFinale)
    }

    validate() {
        let validate = this.state.validateMorbilloRosolia

        for (let key in validate) {
            if (validate[key]) {
                return validate[key]
            }
        }

        return ""
    }

    controlloCorrettezza() {
        let correttezzaStep = this.state.correttezzaStep

        let textList = []

        if(correttezzaStep.casoSospetto && correttezzaStep.casoSospetto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.casoSospetto))
        }
        if(correttezzaStep.datiSegnalazione && correttezzaStep.datiSegnalazione.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.datiSegnalazione))
        }
        if(correttezzaStep.datiPaziente && correttezzaStep.datiPaziente.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.datiPaziente))
        }
        if(correttezzaStep.collettivitaFrequentata && correttezzaStep.collettivitaFrequentata.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.collettivitaFrequentata))
        }
        if(correttezzaStep.statoVaccinale && correttezzaStep.statoVaccinale.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.statoVaccinale))
        }
        if(correttezzaStep.datiClinici && correttezzaStep.datiClinici.length > 0 ){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.datiClinici))
        }
        if(correttezzaStep.confermaDiLaboratorio && correttezzaStep.confermaDiLaboratorio.length > 0 ){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.confermaDiLaboratorio))
        }
        if(correttezzaStep.esamiEComplicanze && correttezzaStep.esamiEComplicanze.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.esamiEComplicanze))
        }
        if(correttezzaStep.ricovero && correttezzaStep.ricovero.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.ricovero))
        }
        if(correttezzaStep.origineDelContagio && correttezzaStep.origineDelContagio.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.origineDelContagio))
        }
        if(correttezzaStep.contattiConDonneInGravidanza && correttezzaStep.contattiConDonneInGravidanza.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.contattiConDonneInGravidanza))
        }
        if(correttezzaStep.classificazioneDelCaso && correttezzaStep.classificazioneDelCaso.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.classificazioneDelCaso))
        }
        if(correttezzaStep.datiDelCompilatore && correttezzaStep.datiDelCompilatore.length > 0 ){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.datiDelCompilatore))
        }

        return textList
    }

    pulisciOggettoBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.oggettoBE))
        Utils.removeEmptyValueFromObject(oggettoBE)
        return oggettoBE
    }

    render() {


        return (
            <div
                className={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "visualizzazione" : ""}>
                <fieldset
                    disabled={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                        this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}>

                    <CasoSospetto
                        createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    />
                    <DatiSegnalazioneMorbillo
                        createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    />
                    <DatiAnagraficiPazienteMorbillo
                        createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        datiPaziente={this.props.datiPaziente}
                    />
                    <CollettivitaFrequentata
                        createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    />
                    <StatoVaccinale
                        createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    />
                    <DatiClinici
                        createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    />
                    <ConfermaDiLaboratorio
                        createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    />
                    <EsamiEComplicanze
                        createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    />
                    <Ricovero
                        createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    />
                    <OrigineDelContagio
                        createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    />
                    <ContattiConDonneInGravidanza
                        createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    />
                    <ClassificazioneDelCaso
                        createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    />
                    <DatiDelCompilatoreMorbillo
                        createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    />
                </fieldset>
            </div>
        );
    }

}

export default withTranslation('common')(SchedaSpecialeMorbilloRosolia)
